import { __assign, __rest } from "tslib";
import React from 'react';
import VeltSidebarButtonCommentsCount from './VeltSidebarButtonCommentsCount/VeltSidebarButtonCommentsCount';
import VeltSidebarButtonIcon from './VeltSidebarButtonIcon/VeltSidebarButtonIcon';
import { transformWireframeProps } from '../../utils/propUtils';
var VeltSidebarButtonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-sidebar-button-wireframe", __assign({}, transformedProps), children));
};
VeltSidebarButtonWireframe.CommentsCount = VeltSidebarButtonCommentsCount;
VeltSidebarButtonWireframe.Icon = VeltSidebarButtonIcon;
export default VeltSidebarButtonWireframe;
